
import { mapGetters, mapState } from 'vuex'
import { slugify } from '~/util/string'

export default {
    props: {
        label: {
            type: String,
            default: null,
        },
        dosage: {
            type: String,
            default: null,
        },
        form: {
            type: String,
            default: null,
        },
        quantity: {
            type: [String, Number],
            default: null,
        },
    },
    data () {
        return {
            trumprxLink: null,
        }
    },
    computed: {
        goodRxUrl () {
            const urlParams = []
            if (this.dosage) urlParams.push(`dosage=${this.dosage}`)
            if (this.form) urlParams.push(`form=${this.form}`)
            if (this.quantity) urlParams.push(`quantity=${this.quantity}`)
            if (this.zip_code) urlParams.push(`location=${this.zip_code}`)
            return `https://www.goodrx.com/${slugify(this.label.trim())}?${urlParams.join('&')}`
        },
        needyMedsUrl () {
            return `https://www.needymeds.org/search-programs?initialSearchTab=drugs&drugQuery=${this.label.trim()}`
        },
        trumprxUrl () {
            if (this.trumprxLink) {
                return this.trumprxLink
            }
            return null
        },
        ...mapGetters(['canAgent']),
        ...mapState({
            zip_code: state => state.survey?.zip_code,
        }),
    },
    mounted () {
        // only show if we're on a page of a group with a slug
        // i.e. /group/:slug/drugs
        if (this.$route.params.slug) {
            this.loadTrumprxPath()
        }
    },
    methods: {
        async loadTrumprxPath () {
            const response = await this.$try('getDrugCosts', {
                sources: 'trumprx',
                label: this.label,
            })
            if (response?.trumprx?.matches?.length) {
                this.trumprxLink = response.trumprx.link
            } else {
                this.trumprxLink = null
            }
        }
    }
}
